/**
 * showToast — lightweight, Redux-free notification utility.
 *
 * Works from any component (no Redux dispatch required).
 * GlobalToast (mounted in App.js) listens for the custom event.
 *
 * Usage:
 *   import { showToast } from '../../utils/toast';
 *   showToast('Saved successfully.', 'success');
 *   showToast('Could not load blueprints.', 'error');
 *   showToast('Generating in background.', 'info');
 */
export function showToast(message, variant = 'info') {
    window.dispatchEvent(
        new CustomEvent('academicos-toast', {
            detail: { message: String(message), variant },
        })
    );
}
